var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-dropdown",
    {
      staticClass: "cursor-pointer",
      attrs: { "vs-custom-content": "", "vs-trigger-click": "" }
    },
    [
      _c("feather-icon", {
        staticClass: "cursor-pointer h-6 w-6",
        attrs: { icon: "BellIcon", badge: _vm.unreadNotifications.length }
      }),
      _c(
        "vs-dropdown-menu",
        {
          staticClass:
            "notification-dropdown dropdown-custom vx-navbar-dropdown"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "notification-top text-center p-1 bg-primary text-white"
            },
            [
              _c("h3", { staticClass: "text-white" }, [
                _vm._v(_vm._s(_vm.unreadNotificationsCount))
              ]),
              _c("p", { staticClass: "opacity-75" }, [
                _vm._v(_vm._s(_vm.notificationWord))
              ])
            ]
          ),
          _c(
            _vm.scrollbarTag,
            {
              key: _vm.$vs.rtl,
              ref: "mainSidebarPs",
              tag: "component",
              staticClass: "scroll-area--nofications-dropdown p-0 mb-4",
              attrs: { settings: _vm.settings }
            },
            [
              _c(
                "ul",
                { staticClass: "bordered-items" },
                _vm._l(_vm.unreadNotifications, function(notification) {
                  return _c(
                    "li",
                    {
                      key: notification.uuid,
                      staticClass:
                        "flex justify-between px-2 py-1 flex-col notification cursor-pointer",
                      on: {
                        click: function($event) {
                          return _vm.clickedNotification(notification)
                        }
                      }
                    },
                    [
                      _c("notification-item", { attrs: { item: notification } })
                    ],
                    1
                  )
                }),
                0
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "\n      checkout-footer\n      fixed\n      bottom-0\n      rounded-b-lg\n      text-primary\n      w-full\n      p-1\n      font-semibold\n      text-center\n      border\n      border-b-0\n      border-l-0\n      border-r-0\n      border-solid\n      d-theme-border-grey-light\n      cursor-pointer"
            },
            [
              _c("span", { on: { click: _vm.openAllNotifications } }, [
                _vm._v("Ver Mais")
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }